if (!customElements.get('its-rail-controls')) {
  customElements.define('its-rail-controls', class extends HTMLElement {
    connectedCallback() {
      this.rail = document.getElementById(this.dataset.railId);
      if (!this.rail) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous = this.querySelector('[data-direction="previous"]');
      this.next = this.querySelector('[data-direction="next"]');
      this.position = this.querySelector('[data-rail-position]');
      this.update = () => {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        const position = Math.abs(this.rail.scrollLeft);
        this.hidden = max < 2;
        this.previous.disabled = position < 2;
        this.next.disabled = position >= max - 2;
        const items = [...this.rail.children];
        const edge = this.rail.getBoundingClientRect();
        const visible = items.filter((item) => {
          const rect = item.getBoundingClientRect();
          return rect.right > edge.left + 2 && rect.left < edge.right - 2;
        });
        const last = items.indexOf(visible.at(-1)) + 1;
        const first = items.indexOf(visible[0]) + 1;
        this.position.textContent = `${String(first).padStart(2, '0')}–${String(last).padStart(2, '0')} / ${String(items.length).padStart(2, '0')}`;
      };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        const direction = button === this.next ? 1 : -1;
        const rtl = getComputedStyle(this.rail).direction === 'rtl' ? -1 : 1;
        const item = this.rail.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        const step = item ? item.getBoundingClientRect().width + gap : this.rail.clientWidth;
        this.rail.scrollBy({
          left: step * direction * rtl,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        });
      }, options);
      this.rail.addEventListener('scroll', this.update, { ...options, passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.rail);
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
